'use client';
import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material';

import ErrorBoundary from '../ErrorBoundary';
import { LinkProps } from '../Link';
import sidekick from '@last-rev/cms-sidekick-util';

import Link from '../Link';
import { useLocalizationContext } from '../LocalizationContext';

export interface BreadcrumbsProps {
  breadcrumbs?: Array<LinkProps>;
  breadcrumbsRoot?: string;
  sidekickLookup?: any;
}

export const Breadcrumbs = ({ breadcrumbs, breadcrumbsRoot, sidekickLookup }: BreadcrumbsProps) => {
  const localization = useLocalizationContext();
  return (
    <ErrorBoundary>
      {breadcrumbs ? (
        <Box p={2} sx={{ display: { xs: 'none', md: 'block' } }} displayPrint="none">
          <Container maxWidth="xl">
            <Grid container>
              <Grid size={{ xs: 12 }}>
                <Root
                  aria-label="breadcrumb"
                  separator="|"
                  data-testid="Breadcrumbs"
                  {...sidekick(sidekickLookup?.categories)}>
                  <Link
                    href="/"
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                    data-testid="Breadcrumbs-breadcrumbsRoot">
                    <ChevronLeftIcon fontSize="small" />
                    {breadcrumbsRoot ?? localization['breadcrumbs.root.label']?.shortTextValue ?? 'Help Center'}
                  </Link>
                  {breadcrumbs?.map((link) => (
                    <Link key={link?.id} href={link?.href} data-testid="Breadcrumbs-link">
                      {link?.text}
                    </Link>
                  ))}
                </Root>
              </Grid>
            </Grid>
          </Container>
        </Box>
      ) : null}
    </ErrorBoundary>
  );
};

const Root = styled(MuiBreadcrumbs, {
  name: 'Breadcrumbs',
  slot: 'root'
})<{}>(({ theme }) => ({
  'padding': theme.spacing(1, 0, 2),
  'fontSize': 15,
  'fontWeight': 500,
  'lineHeight': 1.125,

  '& [class*=separator]': {
    margin: theme.spacing(0, 3),
    color: theme.palette.midnight.main,
    fontWeight: 600
  },

  '& a': {
    'color': theme.palette.midnight.A70,

    '&:hover': {
      color: theme.palette.text.primary,
      textDecoration: 'none'
    },

    '& svg': {
      fill: theme.palette.background.darkGreen
    }
  },

  '& span': {
    cursor: 'default',
    color: theme.palette.midnight.A70,
    fontSize: 15,
    fontWeight: 500
  }
}));

export default Breadcrumbs;
